export const WEEKDAYS = ['mo', 'tu', 'we', 'th', 'fr', 'sa', 'su'];
export const COLORS = ['black', 'yellow', 'blue', 'green', 'pink'];
export const COLOR_CODES = ['#000000', '#FFFF00', '#0000FF', '#008000', '#FFC0CB'];
